<template>
	<div
		:id="`block-${$vnode.key}`"
		class="c-block-list-quote border-l-2 pl-md/h text-theme"
	>
		<div
			v-if="quote"
			class="text-card-title-xl italic font-light whitespace-pre-wrap"
			v-html="quote"
		></div>
		<div
			v-if="origin"
			class="uppercase text-label-sm font-medium mt-xs/v"
			v-html="origin"
		></div>
	</div>
</template>

<script>
export default {
	name: 'BlockListQuote',
	inheritAttrs: false,

	props: {
		origin: {
			type: String,
			default: '',
		},
		quote: {
			type: String,
			default: '',
		},
	},
};
</script>
